import styled from "styled-components";
import { BlockContent } from "~/components/Block";
import { smallerThan } from "~/styles/theme";

const CartAndCheckoutFooter = styled<any>(BlockContent)`
  display: grid;
  grid-template-columns: ${(p) => (p.standalone ? "2fr 1fr" : "1fr")};
  grid-gap: 1rem;
  justify-items: right;
  margin-bottom: 4rem;
  padding: 0;
  margin-top: 2rem;
  a {
    color: #333;
  }
  & > div {
    width: 100%;
    display: grid;
    grid-template-columns: ${(p) => (p.standalone ? "2fr 1fr" : "1fr 1fr")};
    grid-gap: 1rem;
    & > div {
      align-self: center;
      text-align: right;
      font-size: smaller;
    }
  }
  button {
    width: 100%;
  }
  ${(p) => smallerThan(p.theme.breakpoints.small)} {
    grid-template-columns: 1fr;
    justify-items: stretch;
    padding-right: 0;
    padding-left: 0;
    & > div {
      grid-template-columns: 1fr;
      & > div:nth-child(1) {
        order: 2;
        text-align: center;
      }
      & > div:nth-child(2) {
        order: 1;
      }
    }
  }
`;

export default CartAndCheckoutFooter;
